export default __webpack_public_path__ + "static/media/channels_icon.e093fc84.svg";